import React from 'react';
import PropTypes from 'prop-types';
import { basePageWrap } from '../BasePage';
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import ConstructionInfo from '../../components/ConstructionInfo/ConstructionInfo';
import Hero from '../../components/Hero';
import isEmpty from '../../utils/isEmpty';
import NewsListModule from '../../components/NewsListModule';
import ProjectInfo from '../../components/ProjectInfo';
import StreamField from '../../components/StreamField';
import Stepper from '../../components/Stepper';
import i18n from '../../i18n';
import styles from './ProjectPage.module.scss';

const ProjectPage = ({
    breadcrumbs,
    hero,
    contentBlocks,
    stepper,
    title,
    news,
    meta,
    projectInfo,
}) => {
    return (
        <div className={styles['ProjectPage']}>
            {!isEmpty(hero) && <Hero {...hero} />}
            <Breadcrumbs {...breadcrumbs} modifier="ArticlePage" />

            <div className={styles['ProjectPage__Container']}>
                <h1 className={styles['ProjectPage__Title']}>{title}</h1>

                {!isEmpty(stepper) && <Stepper steps={stepper} />}

                <ConstructionInfo {...meta} {...projectInfo} />
                <ProjectInfo {...projectInfo} />

                {!isEmpty(contentBlocks) && (
                    <StreamField items={contentBlocks} />
                )}
            </div>
            {news && news.items && news.items.length > 0 && (
                <NewsListModule
                    heading={i18n.t('projectPage.news')}
                    {...news}
                />
            )}
        </div>
    );
};

ProjectPage.propTypes = {
    breadcrumbs: PropTypes.object,
    hero: PropTypes.object,
    contentBlocks: PropTypes.array,
    title: PropTypes.string,
    preamble: PropTypes.string,
    news: PropTypes.object,
    projectInfo: PropTypes.object,
};

ProjectPage.defaultProps = { hero: {}, projectInfo: {} };

export default basePageWrap(ProjectPage);
